<div class="page-content" *ngIf="!timerService.isForwarding">

     <div><button class="btn-back" title="{{Button.Back_alt | translate}}" (click)="onPreviousClick()" translate>{{Button.Previous}}</button></div>

     <h1 class="page-title" translate>{{'setup_5.page_title'}}</h1>

     <form>
          <div class="padding-botton-10" id="parentCount">
               <ng-radio [item-list]="items.parentCount" id="parentCountRadio" vertical
                    [(ng-model)]="eligibility.listedParentCount" 
                    [(ng-error)]="error_invalidListedParentCount" 
                    (click)="setCertifyingParentCount()"
               >
                    <h2 translate>{{'setup_5.questions.listedParentCount'}}</h2>
               </ng-radio>

               <div class="padding-top-5-bottom-10">
                    <accordion header="setup_5.accordion1.header">
                         <div innerHTML="{{'setup_5.accordion1.content_1' | translate}}">
                         </div>
                         <ul>
                              <li translate = "setup_5.accordion1.content_2"></li>
                              <li translate = "setup_5.accordion1.content_3"></li>
                              <li translate = "setup_5.accordion1.content_4"></li>
                              <li translate = "setup_5.accordion1.content_5"></li>
                              <li translate = "setup_5.accordion1.content_6"></li>
                         </ul>
                         <div translate>
                              {{'setup_5.accordion1.content_7'}}
                         </div>
                    </accordion>
               </div>
          </div>
          <div aria-live='polite'>
          <div class="padding-botton-10" [hidden]="displayCertifyingParentQuestion() == false" id="certifyingParentCount">
               <ng-radio [item-list]="items.parentCount" id="certifyingParentCountRadio" vertical  
                    [(ng-model)]="eligibility.certifyingParentCount" 
                    [(ng-error)]="error_invalidCertifyingParentCount" 
               >
                    <h2 translate>{{"setup_5.questions.certifyingParentCount" | translate}}</h2>
               </ng-radio>
              
               <div class="padding-top-5-bottom-10">
                    <accordion header="setup_5.accordion2.header">
                         <div innerHTML="{{'setup_5.accordion2.content_1' | translate}}">
                         </div>
                         <div class="padding-top-1em">
                              {{'setup_5.accordion2.content_2' | translate}}
                         </div>
                    </accordion>
               </div>
          </div>
          </div>
      </form>
      <div class="btn-div">
               <button class="btn-next" title="{{Button.Next_alt|translate}}" (click)="onNextClick()" translate>
                    {{Button.Next}}
               </button>
      </div>
</div>